import { render } from "./PantryStroageValueDialog.vue?vue&type=template&id=5a8560a7&ts=true"
import script from "./PantryStroageValueDialog.vue?vue&type=script&lang=ts"
export * from "./PantryStroageValueDialog.vue?vue&type=script&lang=ts"

import "./PantryStroageValueDialog.vue?vue&type=style&index=0&id=5a8560a7&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__